var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaior(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.923 20.805",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#809eb6;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Image_Generator",
    "data-name": "Image Generator"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.358,10.494.658,2.527A1.491,1.491,0,0,1,.686.422,1.464,1.464,0,0,1,2.771.45L11.5,9.482a1.493,1.493,0,0,1-.028,2.105l-8.969,8.8A1.466,1.466,0,0,1,.42,20.355,1.493,1.493,0,0,1,.449,18.25Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaior);
export default __webpack_public_path__ + "static/media/maior.d3dbb1108506833e0746a2c3994be788.svg";
export { ForwardRef as ReactComponent };